import script from "./TutorialHelpBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./TutorialHelpBanner.vue?vue&type=script&setup=true&lang=ts"

import "./TutorialHelpBanner.vue?vue&type=style&index=0&id=dd46f5a2&scoped=true&lang=css"
import "./TutorialHelpBanner.vue?vue&type=style&index=1&id=dd46f5a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd46f5a2"]])

export default __exports__